// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
}

body {
  background: #f4f6f8;
  color: #212529;
  line-height: 1.5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.welcome-message {
  text-align: center;
  padding: 0 5px;
  color: #555;
  width: 100%;
  transition: all 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  grid-column: 1/3;
}

.welcome-message h2 {
  font-family: "Montserrat", sans-serif;
  font-size: 1.8rem;
  margin-bottom: 10px;
  color: #333;
}

.welcome-message p {
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
  color: #666;
}

.welcome-gif {
  width: 250px;
  height: 250px;
}

header {
  background: linear-gradient(135deg, #0f1f3c, #2a5298);
  padding: 1rem 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  width: 100%;
}

#weather-form {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 1rem;
}

.left h1 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
}

.right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

#location {
  padding: 0.6rem 0.9rem;
  border-radius: 8px;
  border: none;
  outline: none;
  font-size: 1rem;
  min-width: 230px;
  font-family: "Montserrat", sans-serif;
}

.unit-toggle {
  position: relative;
  width: 70px;
  height: 34px;
}

.unit-toggle input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  background-color: #4caf50;
  border-radius: 34px;
  width: 100%;
  height: 100%;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: bold;
}

.slider::before {
  content: attr(data-unit);
  position: absolute;
  height: 26px;
  width: 26px;
  background-color: #2e7d32;
  color: white;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  left: 6px;
  bottom: 4px;
  transition:
    transform 0.3s,
    background-color 0.3s;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
}

.unit-text {
  z-index: 2;
  transition: color 0.3s;
}

.unit-text.celsius {
  color: #ffffff;
}

.unit-text.fahrenheit {
  color: rgba(255, 255, 255, 0.6);
}

.unit-toggle input:checked + .slider {
  background-color: #2196f3;
}

.unit-toggle input:checked + .slider::before {
  transform: translateX(34px);
  background-color: #1565c0;
}

.unit-toggle input:checked + .slider .unit-text.celsius {
  color: rgba(255, 255, 255, 0.6);
}

.unit-toggle input:checked + .slider .unit-text.fahrenheit {
  color: #ffffff;
}

#search-btn {
  background: #ff7f50;
  border: none;
  border-radius: 8px;
  padding: 8px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    transform 0.2s ease,
    background 0.3s ease;
}

#search-btn:hover {
  background: #e67348;
  transform: scale(1.05);
}

#search-btn svg {
  width: 20px;
  height: 20px;
}

#app {
  flex: 1;
  display: grid;
  gap: 24px;
  padding: 24px;
  width: 100%;
  justify-content: space-around;
  grid-template-columns: 2fr 1fr;
}

.currentForecast {
  background-color: rgba(0, 0, 0, 0.6);
  background-blend-mode: darken;
  backdrop-filter: blur(12px);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: #fff;
  transition: background-image 0.6s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.location {
  text-align: center;
}

.locationHead {
  font-size: 2rem;
  font-weight: bold;
  display: inline-block;
}

.locationCountryCode {
  font-size: 1.1rem;
  opacity: 0.85;
  display: inline-block;
}

.weather-description {
  margin-top: 8px;
}

.sunMoonTimes {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
}

.sunMoonTimes div {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  padding: 12px;
  border-radius: 10px;
  text-align: center;
}

.todaysOverview {
  padding: 16px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 15px 0;
}

.todayHead {
  color: #fff;
  margin-bottom: 10px;
}

.tempCards {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.tempCard {
  background: inherit;
  padding: 12px;
  min-width: 90px;
  text-align: center;
  border-radius: 10px;
  flex-shrink: 0;
  transition: transform 0.2s ease;
  color: #fff;
}

.tempCard:hover {
  transform: translateY(-3px);
}

.tempCard i {
  font-size: 22px;
  margin: 5px 0;
}

.humidityWind {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  color: #212529;
}

.humidityWind div {
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.weeklyForecast {
  display: grid;
  gap: 1rem;
}

.dayCard {
  background: #fff;
  padding: 12px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s ease;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: center;
  align-items: center;
}

.dayCard {
  font-size: 14px;
}

.dayCard:hover {
  transform: translateY(-4px);
}

.dayCard i {
  font-size: 1.8rem;
  margin: 0.5rem 0;
}

.dayCard strong {
  color: #dc3545;
}

.dayCard p:last-child {
  color: #6c757d;
  font-size: 12px;
}

.currentForecast {
  font-size: 14px;
}

.weeklyForecast i {
  color: #a0a0a0;
}

.wi-strong-wind {
  color: #7f8c8d;
}

.wi-sunrise,
.wi-sunset {
  color: #ffb347;
}

.humidityWind i {
  font-size: 14px;
  margin-right: 4px;
}

@media (max-width: 1000px) {
  .tempCard:nth-child(2n) {
    display: none;
  }
  .units {
    justify-content: center;
  }
  #app {
    width: 100%;
    grid-template-columns: 1fr;
    padding: 0;
  }
  .currentForecast {
    padding: 0;
    border-radius: 0 !important;
    min-height: 90vh;
  }
  .weeklyForecast {
    margin-bottom: 15px;
  }
  #location {
    font-size: 12px;
  }
}

@media (max-width: 650px) {
  .sunMoonTimes {
    grid-template-columns: 1fr 1fr;
  }
  .sunMoonTimes > div:last-child {
    grid-row: 2;
    grid-column: 1/3;
  }
}

@media (max-width: 480px) {
  #weather-form h1 {
    font-size: 24px;
  }
  .tempCard {
    min-width: 70px;
  }
  .locationHead {
    font-size: 24px;
  }
  #location {
    width: 80%;
  }
  #app {
    padding: 0;
  }
  .currentForecast {
    border-radius: 0 !important;
    font-size: 12px;
  }
  .locationHead {
    font-size: 18px;
  }
  .weather-description {
    font-size: 12px;
  }
  .locationCountryCode {
    font-size: 14px;
  }
  .dayCard {
    font-size: 12px;
  }
  .right {
    justify-content: flex-end;
  }
}

footer {
  text-align: center;
  padding: 1rem 0;
  background-color: #ffffff;
  font-size: 14px;
  color: #555;
  border-top: 1px solid #ddd;
  width: 100%;
}
footer a {
  color: #0366d6;
  text-decoration: none;
}
footer a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX;;yBAEuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;wBAEsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,SAAS;EACT,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,WAAW;EACX,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;EAC/B,aAAa;EACb,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,UAAU;IACV,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap\");\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  font-family: \"Montserrat\", sans-serif;\r\n}\r\n\r\nbody {\r\n  background: #f4f6f8;\r\n  color: #212529;\r\n  line-height: 1.5;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.welcome-message {\r\n  text-align: center;\r\n  padding: 0 5px;\r\n  color: #555;\r\n  width: 100%;\r\n  transition: all 0.3s ease-in-out;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  grid-column: 1/3;\r\n}\r\n\r\n.welcome-message h2 {\r\n  font-family: \"Montserrat\", sans-serif;\r\n  font-size: 1.8rem;\r\n  margin-bottom: 10px;\r\n  color: #333;\r\n}\r\n\r\n.welcome-message p {\r\n  font-family: \"Montserrat\", sans-serif;\r\n  font-size: 1rem;\r\n  color: #666;\r\n}\r\n\r\n.welcome-gif {\r\n  width: 250px;\r\n  height: 250px;\r\n}\r\n\r\nheader {\r\n  background: linear-gradient(135deg, #0f1f3c, #2a5298);\r\n  padding: 1rem 2rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n  width: 100%;\r\n}\r\n\r\n#weather-form {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n}\r\n\r\n.left h1 {\r\n  font-size: 1.8rem;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n#location {\r\n  padding: 0.6rem 0.9rem;\r\n  border-radius: 8px;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 1rem;\r\n  min-width: 230px;\r\n  font-family: \"Montserrat\", sans-serif;\r\n}\r\n\r\n.unit-toggle {\r\n  position: relative;\r\n  width: 70px;\r\n  height: 34px;\r\n}\r\n\r\n.unit-toggle input {\r\n  display: none;\r\n}\r\n\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  background-color: #4caf50;\r\n  border-radius: 34px;\r\n  width: 100%;\r\n  height: 100%;\r\n  transition: background-color 0.3s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n}\r\n\r\n.slider::before {\r\n  content: attr(data-unit);\r\n  position: absolute;\r\n  height: 26px;\r\n  width: 26px;\r\n  background-color: #2e7d32;\r\n  color: white;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  left: 6px;\r\n  bottom: 4px;\r\n  transition:\r\n    transform 0.3s,\r\n    background-color 0.3s;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.unit-text {\r\n  z-index: 2;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.unit-text.celsius {\r\n  color: #ffffff;\r\n}\r\n\r\n.unit-text.fahrenheit {\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.unit-toggle input:checked + .slider {\r\n  background-color: #2196f3;\r\n}\r\n\r\n.unit-toggle input:checked + .slider::before {\r\n  transform: translateX(34px);\r\n  background-color: #1565c0;\r\n}\r\n\r\n.unit-toggle input:checked + .slider .unit-text.celsius {\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.unit-toggle input:checked + .slider .unit-text.fahrenheit {\r\n  color: #ffffff;\r\n}\r\n\r\n#search-btn {\r\n  background: #ff7f50;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 8px 10px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition:\r\n    transform 0.2s ease,\r\n    background 0.3s ease;\r\n}\r\n\r\n#search-btn:hover {\r\n  background: #e67348;\r\n  transform: scale(1.05);\r\n}\r\n\r\n#search-btn svg {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n#app {\r\n  flex: 1;\r\n  display: grid;\r\n  gap: 24px;\r\n  padding: 24px;\r\n  width: 100%;\r\n  justify-content: space-around;\r\n  grid-template-columns: 2fr 1fr;\r\n}\r\n\r\n.currentForecast {\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n  background-blend-mode: darken;\r\n  backdrop-filter: blur(12px);\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  color: #fff;\r\n  transition: background-image 0.6s ease-in-out;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-around;\r\n}\r\n\r\n.location {\r\n  text-align: center;\r\n}\r\n\r\n.locationHead {\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n  display: inline-block;\r\n}\r\n\r\n.locationCountryCode {\r\n  font-size: 1.1rem;\r\n  opacity: 0.85;\r\n  display: inline-block;\r\n}\r\n\r\n.weather-description {\r\n  margin-top: 8px;\r\n}\r\n\r\n.sunMoonTimes {\r\n  margin-top: 1rem;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.sunMoonTimes div {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  backdrop-filter: blur(8px);\r\n  padding: 12px;\r\n  border-radius: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.todaysOverview {\r\n  padding: 16px;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 15px 0;\r\n}\r\n\r\n.todayHead {\r\n  color: #fff;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.tempCards {\r\n  display: flex;\r\n  gap: 12px;\r\n  overflow-x: auto;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.tempCard {\r\n  background: inherit;\r\n  padding: 12px;\r\n  min-width: 90px;\r\n  text-align: center;\r\n  border-radius: 10px;\r\n  flex-shrink: 0;\r\n  transition: transform 0.2s ease;\r\n  color: #fff;\r\n}\r\n\r\n.tempCard:hover {\r\n  transform: translateY(-3px);\r\n}\r\n\r\n.tempCard i {\r\n  font-size: 22px;\r\n  margin: 5px 0;\r\n}\r\n\r\n.humidityWind {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 12px;\r\n  color: #212529;\r\n}\r\n\r\n.humidityWind div {\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: #fff;\r\n}\r\n\r\n.weeklyForecast {\r\n  display: grid;\r\n  gap: 1rem;\r\n}\r\n\r\n.dayCard {\r\n  background: #fff;\r\n  padding: 12px;\r\n  border-radius: 12px;\r\n  text-align: center;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\r\n  transition: transform 0.2s ease;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.dayCard {\r\n  font-size: 14px;\r\n}\r\n\r\n.dayCard:hover {\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.dayCard i {\r\n  font-size: 1.8rem;\r\n  margin: 0.5rem 0;\r\n}\r\n\r\n.dayCard strong {\r\n  color: #dc3545;\r\n}\r\n\r\n.dayCard p:last-child {\r\n  color: #6c757d;\r\n  font-size: 12px;\r\n}\r\n\r\n.currentForecast {\r\n  font-size: 14px;\r\n}\r\n\r\n.weeklyForecast i {\r\n  color: #a0a0a0;\r\n}\r\n\r\n.wi-strong-wind {\r\n  color: #7f8c8d;\r\n}\r\n\r\n.wi-sunrise,\r\n.wi-sunset {\r\n  color: #ffb347;\r\n}\r\n\r\n.humidityWind i {\r\n  font-size: 14px;\r\n  margin-right: 4px;\r\n}\r\n\r\n@media (max-width: 1000px) {\r\n  .tempCard:nth-child(2n) {\r\n    display: none;\r\n  }\r\n  .units {\r\n    justify-content: center;\r\n  }\r\n  #app {\r\n    width: 100%;\r\n    grid-template-columns: 1fr;\r\n    padding: 0;\r\n  }\r\n  .currentForecast {\r\n    padding: 0;\r\n    border-radius: 0 !important;\r\n    min-height: 90vh;\r\n  }\r\n  .weeklyForecast {\r\n    margin-bottom: 15px;\r\n  }\r\n  #location {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 650px) {\r\n  .sunMoonTimes {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n  .sunMoonTimes > div:last-child {\r\n    grid-row: 2;\r\n    grid-column: 1/3;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  #weather-form h1 {\r\n    font-size: 24px;\r\n  }\r\n  .tempCard {\r\n    min-width: 70px;\r\n  }\r\n  .locationHead {\r\n    font-size: 24px;\r\n  }\r\n  #location {\r\n    width: 80%;\r\n  }\r\n  #app {\r\n    padding: 0;\r\n  }\r\n  .currentForecast {\r\n    border-radius: 0 !important;\r\n    font-size: 12px;\r\n  }\r\n  .locationHead {\r\n    font-size: 18px;\r\n  }\r\n  .weather-description {\r\n    font-size: 12px;\r\n  }\r\n  .locationCountryCode {\r\n    font-size: 14px;\r\n  }\r\n  .dayCard {\r\n    font-size: 12px;\r\n  }\r\n  .right {\r\n    justify-content: flex-end;\r\n  }\r\n}\r\n\r\nfooter {\r\n  text-align: center;\r\n  padding: 1rem 0;\r\n  background-color: #ffffff;\r\n  font-size: 14px;\r\n  color: #555;\r\n  border-top: 1px solid #ddd;\r\n  width: 100%;\r\n}\r\nfooter a {\r\n  color: #0366d6;\r\n  text-decoration: none;\r\n}\r\nfooter a:hover {\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
